import { render } from "./CookiebarGlobalArea.ce.vue?vue&type=template&id=0e078d1e"
import script from "./CookiebarGlobalArea.ce.vue?vue&type=script&lang=js"
export * from "./CookiebarGlobalArea.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__